import {Action, Card, useDialog} from 'platform/components';
import {Box} from 'platform/foundation';

import {useDispatch} from 'react-redux';

import {mergeAll} from 'ramda';

import {documentContextApi} from '@dms/api/core';
import {
  DOCUMENT_ACTION_COLUMNS,
  useGetDocumentDatagridActions,
} from '@dms/features/document-context';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {DmsDataGrid, Main, refreshDmsDatagrid, UploadDocumentsDialog} from '@dms/shared';

import {buildArray, useRequiredParams} from 'shared/web';

import type {ActionCallback, EagGridMaximization, QueryFilterObject} from 'features/eag-grid';

interface VehicleDocumentsProps {
  maximization?: EagGridMaximization;
}

export function VehicleDocuments(props: VehicleDocumentsProps) {
  const {id: vehicleId} = useRequiredParams();

  const dispatch = useDispatch();

  const refreshDataGrid = () => {
    refreshDmsDatagrid('document-context-list-vehicle');
  };
  const [actionCallback, bulkSignatureAction] = useGetDocumentDatagridActions({
    contextId: vehicleId,
    contextTarget: 'vehicle',
    refreshData: refreshDataGrid,
  });

  const [isUploadDialogOpen, openUploadDialog, closeUploadDialog] = useDialog();

  const onDocumentCreated = () => {
    refreshDataGrid();

    dispatch(
      documentContextApi.util.invalidateTags([{type: 'documentsCount', id: vehicleId ?? ''}])
    );
  };

  const queryModifier = (filter: QueryFilterObject) => mergeAll([filter, {vehicleId}]);

  return (
    <Main>
      <Card
        title={i18n.t('page.vehicle.documents.title')}
        actions={buildArray<Action>([
          {
            variant: 'link',
            type: 'button',
            leftIcon: 'action/backup',
            onClick: openUploadDialog,
            title: i18n.t('entity.document.actions.uploadDocument'),
          },
        ]).add(...bulkSignatureAction)}
      >
        <Box height={130} minHeight={50} position="relative">
          <DmsDataGrid
            maximization={props.maximization}
            gridCode="document-context-list-vehicle"
            emptyState={{
              headline: i18n.t('page.vehicle.notifications.noDocuments'),
              subheadline: i18n.t('page.vehicle.notifications.documentListWillAppearHere'),
            }}
            actionCallback={actionCallback as ActionCallback<typeof DOCUMENT_ACTION_COLUMNS>}
            predefinedColumns={DOCUMENT_ACTION_COLUMNS}
            data-testid={testIds.vehicles.documents('document-context-list-vehicle')}
            queryModifier={queryModifier}
          />
        </Box>
      </Card>
      <UploadDocumentsDialog
        isOpen={isUploadDialogOpen}
        handleClose={closeUploadDialog}
        onDocumentCreated={onDocumentCreated}
        contextTarget="vehicle"
        contextId={vehicleId}
      />
    </Main>
  );
}
